// SE1 (7.3b) — rich accommodation-notification bridge (the UIHelper
// showNotification consumer with action buttons + destroy-by-key). Same
// registered-impl pattern as apNotify: App registers a sonner impl (action
// mapping) at module load. R15 (7.5): the lazy antd branch is gone with the
// v1 shell — unregistered = no-op; call sites never moved.

export type AccommodationToastArgs = {
  type: 'success' | 'info' | 'warning';
  key: string;
  title: string;
  message: string;
  buttonText: string;
  onButtonClick: () => void;
};

export type PreviewAccommodationToastArgs = {
  key: string;
  title: string;
  message: string;
};

export type AccommodationNotifyImpl = {
  show: (args: AccommodationToastArgs) => void;
  showPreview: (args: PreviewAccommodationToastArgs) => void;
  dismiss: (key: string) => void;
};

let v4Impl: AccommodationNotifyImpl | null = null;

export const registerV4AccommodationNotify = (impl: AccommodationNotifyImpl): void => {
  v4Impl = impl;
};

/** R15: antd impl chunk deleted — nothing to preload (kept: call sites never move). */
export const preloadAccommodationNotify = (): void => undefined;

const dispatch = (fn: (impl: AccommodationNotifyImpl) => void): void => {
  if (v4Impl) fn(v4Impl);
};

export const accommodationNotify = {
  show: (args: AccommodationToastArgs): void => dispatch((impl) => impl.show(args)),
  showPreview: (args: PreviewAccommodationToastArgs): void =>
    dispatch((impl) => impl.showPreview(args)),
  dismiss: (key: string): void => dispatch((impl) => impl.dismiss(key)),
};
